class Demand {
    constructor() {
        this.id = null
        this.curve = ''
    }

    static get fieldNames() {
        return {
            id: 'ID',
            datetime_created: 'Data',
            product_id: 'ID Produto',
            product_name: 'Descrição',
            curve: 'Curva',
            product_reference: 'Referência',
            branch: 'Filial',
            current_week: 'Semana Atual',
            first_week: 'Primeira Semana',
            second_week: 'Segunda Semana',
            current_stock: 'Estoque',
            error_percentage: 'Erro %'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            datetime_created: 'datetime-local',
            product_id: 'text',
            product_name: 'text',
            curve: 'text',
            product_reference: 'text',
            branch: 'text',
            current_week: 'number',
            first_week: 'number',
            second_week: 'number',
            current_stock: 'number',
            error_percentage: 'number'
        }
    }

    static get visibleFields() {
        return {
            id: false,
            datetime_created: true,
            product_id: true,
            product_name: true,
            curve: true,
            product_reference: true,
            branch: true,
            current_week: true,
            first_week: true,
            second_week: true,
            current_stock: true,
            error_percentage: true
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            datetime_created: false,
            product_id: false,
            product_name: false,
            curve: false,
            product_reference: false,
            branch: false,
            current_week: false,
            first_week: false,
            second_week: false,
            current_stock: false,
            error_percentage: false
        }
    }

    static get createFields() {
        return {
            quantity: true,
            aggregation_type: true,
            datetime_nap: true,
            branch_id: true,
            product_id: true,
            status: true
        }
    }
}

export default Demand

export { Demand }
